import React from 'react';
import { Text, View } from 'react-native';
import { ThemeColors } from '@/src/context/ThemeContext';
import { BlogPost } from '@/src/domain/models/BlogPost';

const TeamsContent: React.FC<{ colors: ThemeColors }> = ({ colors }) => (
  <View>
    <Text style={{ fontSize: 16, lineHeight: 26, color: colors.text, marginBottom: 20 }}>
      Today we're launching Teams — a new way to organize and compete together in Tournaly.
      You can now create a team, invite your crew, manage your roster, and take on other
      teams across tournaments.
    </Text>

    <Text style={{ fontSize: 20, fontWeight: '700', color: colors.text, marginBottom: 12, marginTop: 8 }}>
      What's included
    </Text>

    {[
      'Create a team with a name, description, and public/private visibility',
      'Invite players by email — they receive an in-app notification',
      'Accept or decline team invitations from your Invitations screen',
      'Manage your roster: promote members, remove players, or leave a team',
      'Explore public teams and discover communities you can join',
      'Free plan: 1 active team. Pro plan: unlimited teams',
    ].map((item, index) => (
      <View key={index} style={{ flexDirection: 'row', marginBottom: 10, alignItems: 'flex-start' }}>
        <Text style={{ color: colors.primary, marginRight: 10, fontSize: 16 }}>•</Text>
        <Text style={{ fontSize: 15, lineHeight: 23, color: colors.textSecondary, flex: 1 }}>{item}</Text>
      </View>
    ))}

    <Text style={{ fontSize: 20, fontWeight: '700', color: colors.text, marginBottom: 12, marginTop: 24 }}>
      What's coming next
    </Text>

    <Text style={{ fontSize: 16, lineHeight: 26, color: colors.text, marginBottom: 20 }}>
      Phase 2 will bring tournament-level team support: register a whole team as a participant,
      view team standings in leagues, and team-vs-team brackets. Stay tuned.
    </Text>

    <Text style={{ fontSize: 16, lineHeight: 26, color: colors.textSecondary }}>
      Teams are available today for all Tournaly users. Head to the Teams section in the
      navigation drawer to get started.
    </Text>
  </View>
);

const TeamsContentEs: React.FC<{ colors: ThemeColors }> = ({ colors }) => (
  <View>
    <Text style={{ fontSize: 16, lineHeight: 26, color: colors.text, marginBottom: 20 }}>
      Hoy lanzamos Equipos — una nueva forma de organizarse y competir juntos en Tournaly.
      Ahora puedes crear un equipo, invitar a tus amigos, gestionar tu plantilla y enfrentarte
      a otros equipos en torneos.
    </Text>

    <Text style={{ fontSize: 20, fontWeight: '700', color: colors.text, marginBottom: 12, marginTop: 8 }}>
      Qué incluye
    </Text>

    {[
      'Crea un equipo con nombre, descripción y visibilidad pública o privada',
      'Invita jugadores por email — recibirán una notificación en la app',
      'Acepta o rechaza invitaciones de equipo desde tu pantalla de Invitaciones',
      'Gestiona tu plantilla: promueve miembros, elimina jugadores o abandona el equipo',
      'Explora equipos públicos y descubre comunidades a las que unirte',
      'Plan gratuito: 1 equipo activo. Plan Pro: equipos ilimitados',
    ].map((item, index) => (
      <View key={index} style={{ flexDirection: 'row', marginBottom: 10, alignItems: 'flex-start' }}>
        <Text style={{ color: colors.primary, marginRight: 10, fontSize: 16 }}>•</Text>
        <Text style={{ fontSize: 15, lineHeight: 23, color: colors.textSecondary, flex: 1 }}>{item}</Text>
      </View>
    ))}

    <Text style={{ fontSize: 20, fontWeight: '700', color: colors.text, marginBottom: 12, marginTop: 24 }}>
      Próximamente
    </Text>

    <Text style={{ fontSize: 16, lineHeight: 26, color: colors.text, marginBottom: 20 }}>
      La fase 2 traerá soporte de equipos en torneos: registra todo un equipo como participante,
      consulta clasificaciones por equipo en ligas y brackets equipo contra equipo. Próximamente.
    </Text>

    <Text style={{ fontSize: 16, lineHeight: 26, color: colors.textSecondary }}>
      Los Equipos están disponibles hoy para todos los usuarios de Tournaly. Dirígete a la sección
      Equipos en el menú de navegación para empezar.
    </Text>
  </View>
);

export const post: BlogPost = {
  slug: '2026-03-05-teams',
  title: 'Introducing Teams: Compete Together',
  titleEs: 'Presentamos Equipos: Compite Junto',
  date: '2026-03-05',
  summary: 'Tournaly now supports teams — create a team tournament roster, invite players by email, manage members, and compete together across multiple tournaments and leagues.',
  summaryEs: 'Tournaly soporta ahora equipos — crea una plantilla de torneo, invita jugadores por email, gestiona miembros y compite junto en múltiples torneos y ligas.',
  tags: ['Teams', 'Feature'],
  Content: TeamsContent,
  ContentEs: TeamsContentEs,
};
